import layoutComponent from "materials/layout/render/index.vue"
import layoutComponentBigScreen from "./elementComponents/layoutBigScreen/index.vue"
import cxSwitch from "components/elementComponents/switch/index.vue" //cxSwitch
import cacheComponent from "./elementComponents/cacheComponent/index.vue"
import cxEarth from "materials/bigScreen/earth/render/index.vue" //cxEarth
import cxMap from "materials/bigScreen/map/render/index.vue" //cxMap
import cxPageLayout from "materials/pageLayout/render/index.vue"
import cxPageLayoutComponent from "materials/pageLayoutComponent/render/index.vue"
import { materialLoader } from "core/materialLoader"
export default {
  components: {
    layoutComponent,
    layoutComponentBigScreen,
    cxSwitch,
    cacheComponent,
    cxMap: cxEarth,
    cxRealMap: cxMap,
    cxPageLayout,
    cxPageLayoutComponent,
    ...materialLoader.getAllRenderComponentsMixin()
  }
}
